;(function () {
	const initMegaSubmenu = (header) => {
		const megaSubmenuLinks = header.querySelectorAll('.list-menu-has-child')
		if (!megaSubmenuLinks || !megaSubmenuLinks.length) return
		megaSubmenuLinks.forEach((link) => {
			const tabs = link.querySelectorAll('.mega-submenu__tab')

			if (!tabs?.[0]?.classList.contains('active')) {
				tabs.forEach((tabItem) => {
					tabItem.classList.add('active')
				})
			}
			const submenus = link.querySelectorAll('.mega-submenu__submenu')
			const onToggle = (event) => {
				const tab = event.target
				if (!tab || !tab.classList.contains('mega-submenu__tab')) return
				const tabId = tab.dataset.tabId
				tabs.forEach((tab) => {
					tab.classList.remove('active')
				})
				tab.classList.add('active')
				submenus.forEach((submenu) => {
					submenu.classList.remove('active')
					if (submenu.dataset.tabId === tabId) {
						submenu.classList.add('active')
					}
				})
			}
			tabs.forEach((tab) => {
				tab.addEventListener('click', onToggle)
				tab.addEventListener('mouseenter', onToggle)
			})
		})
	}
	const header = () => {
		const body = document.querySelector('body')
		const header = document.querySelector('.shopify-section-header')
		const headerDetails = document.querySelector('.menu-drawer-container')
		const headerIsAlwaysSticky =
			header
				.querySelector('.header-wrapper')
				.getAttribute('data-sticky-type') === 'always'
		headerDetails.addEventListener('toggle', function (e) {
			const colorScheme = this.querySelector('#menu-drawer').dataset.colorScheme
			header.classList.toggle(colorScheme)
		})
		document.addEventListener('keyup', (e) => {
			if (e.key === 'Escape') {
				header.classList.remove('shopify-section-header-sticky', 'animate')
				body.classList.remove('overflow-hidden')
			}
		})
		document.addEventListener('scroll', () => {
			let scrollTop = window.scrollY
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add('fixed', 'animate')
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove('fixed', 'animate')
			}
		})
		const headerAllDetails = document.querySelectorAll('.header details')
		headerAllDetails.forEach((details) => {
			details.addEventListener('click', function (e) {
				if (window.matchMedia('(max-width: 1099px)').matches) return false
				const disclosureList = document.querySelectorAll(
					'.header .disclosure__list'
				)
				disclosureList.forEach((list) => {
					if (list.hasAttribute('hidden')) return
					list.setAttribute('hidden', 'true')
					list.previousElementSibling.setAttribute('aria-expanded', 'false')
				})
			})
		})
		if (header && document.body.classList.contains('body-template-index')) {
			header.addEventListener('mouseenter', () => {
				if (!header.classList.contains('fixed')) {
					header.classList.add('fixed')
					header.dataset.hoverFixed = 'true'
				}
			})
			header.addEventListener('mouseleave', () => {
				if (header.dataset.hoverFixed === 'true') {
					let scrollTop = window.scrollY
					if (scrollTop <= header.offsetHeight) {
						header.classList.remove('fixed')
					}
					delete header.dataset.hoverFixed
				}
			})
		}
		initMegaSubmenu(header)
	}
	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)
	header()
})()
